import React from "react";
import {
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FaSort } from "react-icons/fa";
import { HeaderDiv } from "../../style/Table.style";
import "./table.css";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    // background: `linear-gradient(to right, #6dd5ed, #CCFFFF)`,
    fontWeight: 'black',                           
    background: '#ffff',
  },
}));

function TableComp(props) {
  return (
    <div>
      <Table
        {...props.getTableProps()}
        sx={{ minWidth: 650 }}
        aria-label="simple table"
      >
        <TableHead className="table-head">
          {props.headerGroups.map((headerGroup) => (
            <TableRow {...headerGroup.getHeaderGroupProps()} style={{}}>
              <TableCell
                sx={{
                  padding: ".75rem 1rem",
                }}
                style={{
                  backgroundColor: "#a2bdfc",
                  fontWeight: "bold",
                  color: "#2b3445",
                }}
              >
                Sl No
              </TableCell>
              {headerGroup.headers.map((column) => (
                <TableCell
                  sx={{
                    padding: ".5rem 1rem",
                  }}
                  style={{
                    backgroundColor: "#a2bdfc",
                    fontWeight: "bold",
                    color: "#2b3445",
                  }}
                  {...column.getHeaderProps()}
                >
                  {props.sortIcon ? (
                    <HeaderDiv {...column.getSortByToggleProps()}>
                      {column.render("Header")}
                      <FaSort />
                    </HeaderDiv>
                  ) : (
                    <HeaderDiv {...column.getSortByToggleProps()}>
                      {column.render("Header")}
                      <FaSort className="sort-icon" />
                    </HeaderDiv>
                  )}

                  <div>{column.canFilter ? column.render("Filter") : null}</div>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableHead>
        <TableBody {...props.getTableBodyProps()}>
          {props.page.map((row, index) => {
            props.prepareRow(row);
            return (
              <StyledTableRow {...row.getRowProps()} key={index}>
                <TableCell
                  sx={{
                    padding: ".3rem 1rem",
                    color: "#0c3f85",
                    fontWeight: "500",
                  }}
                >
                  {index + 1 + props.pageIndex * 10}
                </TableCell>
                {row.cells.map((cell) => {
                 
                  return (
                    <TableCell
                      sx={{
                        padding: ".3rem 1rem",
                      }}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </TableCell>
                  );
                })}
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

export default TableComp;
